import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { uploadFile } from "@/lib/upload13";

export const money = (v) => `$${Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;

export function useBlobUrl(url) {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    if (!url) return undefined;
    let u = null;
    let live = true;
    api.get(url, { responseType: "blob" }).then(({ data }) => { if (live) { u = URL.createObjectURL(data); setSrc(u); } }).catch(() => {});
    return () => { live = false; if (u) URL.revokeObjectURL(u); };
  }, [url]);
  return src;
}

export function Thumb({ url, alt, className = "h-20 w-20", testid }) {
  const src = useBlobUrl(url);
  return (
    <span className={`inline-flex shrink-0 items-center justify-center overflow-hidden rounded-xl bg-q-raised ${className}`} data-testid={testid}>
      {src && <img src={src} alt={alt} className="h-full w-full object-contain" />}
    </span>
  );
}

export async function uploadMany(base, files) {
  const ids = [];
  for (const f of files) ids.push(await uploadFile(base, f));
  return ids;
}

export async function download(url, body, name) {
  try {
    const { data, headers } = await api.post(url, body, { responseType: "blob" });
    const cd = headers["content-disposition"] || "";
    const a = document.createElement("a");
    a.href = URL.createObjectURL(data);
    a.download = (cd.match(/filename="([^"]+)"/) || [])[1] || name;
    a.click();
    setTimeout(() => URL.revokeObjectURL(a.href), 60000);
    return true;
  } catch (e) {
    toast.error(e.response?.status === 500 ? "Export failed. Try again." : errMsg(e));
    return false;
  }
}
